/**
 * Komal OS - KRA Quarterly Store
 * Powers the CEO Quarterly Dashboard and calibration flow
 */

import { create } from 'zustand';
import * as kraQuarterlyService from '../services/kraQuarterlyService';

const useKraQuarterlyStore = create((set, get) => ({
  dashboard: [],
  review: null,
  auditLog: [],
  isLoading: false,
  isSubmitting: false,
  error: null,

  clearError: () => set({ error: null }),

  fetchDashboard: async (year, quarterNumber, departmentId) => {
    set({ isLoading: true, error: null });
    try {
      const response = await kraQuarterlyService.getQuarterlyDashboard(year, quarterNumber, departmentId);
      set({ dashboard: response.data.employees || [], isLoading: false });
      return response.data.employees;
    } catch (error) {
      const message = error.response?.data?.detail || 'Failed to load the quarterly dashboard';
      set({ error: message, isLoading: false });
      return [];
    }
  },

  fetchReview: async (employeeId, year, quarterNumber) => {
    set({ isLoading: true, error: null });
    try {
      const response = await kraQuarterlyService.getQuarterlyReview(employeeId, year, quarterNumber);
      set({ review: response.data, isLoading: false });
      return response.data;
    } catch (error) {
      const message = error.response?.data?.detail || 'Failed to load the quarterly review';
      set({ error: message, isLoading: false });
      return null;
    }
  },

  submitCalibration: async (data) => {
    set({ isSubmitting: true, error: null });
    try {
      const response = await kraQuarterlyService.submitCalibration(data);
      await get().fetchReview(data.employee_id, data.year, data.quarter_number);
      set({ isSubmitting: false });
      return { success: true, data: response.data };
    } catch (error) {
      const message = error.response?.data?.detail || 'Failed to save calibration';
      set({ error: message, isSubmitting: false });
      return { success: false, error: message };
    }
  },

  fetchAuditLog: async (params = {}) => {
    set({ isLoading: true, error: null });
    try {
      const response = await kraQuarterlyService.getKraAuditLog(params);
      set({ auditLog: response.data.audit_log || [], isLoading: false });
      return response.data.audit_log;
    } catch (error) {
      const message = error.response?.data?.detail || 'Failed to load the audit log';
      set({ error: message, isLoading: false });
      return [];
    }
  },
}));

export default useKraQuarterlyStore;
